import { forwardRef, type Ref, type SVGProps } from 'react';
import { SvgIcon } from '../../components/icon/icon';

interface SVGRProps {
  title?: string;
  titleId?: string;
}
const ColourPalette = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    ref={ref}
    aria-labelledby={titleId}
    {...props}>
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M22 12.883C22 7.287 17.523 2.75 12 2.75S2 7.287 2 12.883c0 5.597 3.477 8.367 9 8.367 1.86 0 1.882-.648 1.524-1.5-.411-.98-1.327-2.228-.524-3.067 1.925-1.519 10 3.8 10-3.8m-3-.633a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0m-3-4a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0m-5 0a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0m-3 4a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0"
      vectorEffect="non-scaling-stroke"
    />
  </svg>
);
const ForwardRef = forwardRef(ColourPalette) as SvgIcon;
export { ForwardRef as ReactComponent };
